import React from 'react';
import PropTypes from 'prop-types';

import './switch.scss';

const Switch = ({ index, name, onChange, label, checked, disabled, onLabel, offLabel }) => (
  <div className="c-switch" key={`switch-${index}`}>
    <input
      checked={checked}
      className="c-switch__input"
      disabled={disabled}
      id={`switch-${index}`}
      name={name}
      onChange={onChange}
      type="checkbox"
    />
    <label className="c-switch__label" htmlFor={`switch-${index}`}>
      <span className="c-switch__label-inner" data-on-label={onLabel} data-off-label={offLabel} />
      <span className="c-switch__label-switch" />
    </label>
  </div>
);

Switch.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string,
  name: PropTypes.string,
  offLabel: PropTypes.string,
  onChange: PropTypes.func,
  onLabel: PropTypes.string,
};

Switch.defaultProps = {
  offLabel: 'Disabled',
  onLabel: 'Enabled',
};

export default Switch;
